<div class="d-flex justify-content-between">
  <div class="col-md-6 col-lg-6">
    <div class="locations-header loc">Top items ordered by total amount</div>
    <div class="table-responsive">
      <table class="table">
        <th>Order Item</th>
        <th class="text-right">Currency</th>
        <th class="text-right">Amount</th>
        <tr *ngFor="let col of TOP_ITEMS_AMOUNT">
          <td>{{ col.order_item_name }}</td>
          <td class="text-right">
            <span style="color: #44546a">{{ col.currency }}</span>
          </td>
          <td class="text-right">
            <span style="color: #44546a">
              {{ col.amount | number : "1.2-2" }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="col-md-6 col-lg-6">
    <div class="locations-header loc">Top items ordered by total count</div>
    <div class="table-responsive">
      <table class="table">
        <th>Order Item</th>
        <th class="text-right">Count</th>
        <tr *ngFor="let col of TOP_ITEMS_TOTAL_COUNT">
          <td>{{ col.order_item_name }}</td>
          <td class="text-right">
            <span style="color: #44546a"> {{ col.count }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
